module.exports = new __parcel__URL__("footer_grass.e7110f89.svg").toString();